import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface selectRecordsData {
  ballotTableData: any[]; // 👈 array, not Record
}

const initialState: selectRecordsData = {
  ballotTableData: [],
};

const ballotListings = createSlice({
  name: "ballotTableData",
  initialState,
  reducers: {
    addAllBallotDetails: (
      state,
      action: PayloadAction<{ value: any[] }>
    ) => {
      state.ballotTableData = action.payload.value;
    },
    clearAllBallotDetails: (state) => {
      state.ballotTableData = []; // 👈 reset when re-fetching
    },
  },
});

export const allBallotListings = ballotListings.actions;
export default ballotListings.reducer;
